/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_TitleInputs */

const en_audio_recorder_title = /** @type {(inputs: Audio_Recorder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio Recorder`)
};

const fr_audio_recorder_title = /** @type {(inputs: Audio_Recorder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistreur audio`)
};

const de_audio_recorder_title = /** @type {(inputs: Audio_Recorder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audiorecorder`)
};

const it_audio_recorder_title = /** @type {(inputs: Audio_Recorder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registratore audio`)
};

const ru_audio_recorder_title = /** @type {(inputs: Audio_Recorder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аудиозапись`)
};

const es_audio_recorder_title = /** @type {(inputs: Audio_Recorder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grabadora de audio`)
};

const zh_cn2_audio_recorder_title = /** @type {(inputs: Audio_Recorder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`录音机`)
};

const ja_audio_recorder_title = /** @type {(inputs: Audio_Recorder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオレコーダー`)
};

const hi_audio_recorder_title = /** @type {(inputs: Audio_Recorder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो रिकॉर्डर`)
};

const pt_pt2_audio_recorder_title = /** @type {(inputs: Audio_Recorder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gravador de áudio`)
};

/**
* | output |
* | --- |
* | "Audio Recorder" |
*
* @param {Audio_Recorder_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_title = /** @type {((inputs?: Audio_Recorder_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_title(inputs)
	if (locale === "de") return de_audio_recorder_title(inputs)
	if (locale === "it") return it_audio_recorder_title(inputs)
	if (locale === "ru") return ru_audio_recorder_title(inputs)
	if (locale === "es") return es_audio_recorder_title(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_title(inputs)
	if (locale === "ja") return ja_audio_recorder_title(inputs)
	if (locale === "hi") return hi_audio_recorder_title(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_title(inputs)
	return en_audio_recorder_title(inputs)
});